import { FC } from "react";

const Settings: FC = () => {
  return <h1>Settings</h1>;
};
export default Settings;
